import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { useLang } from "../context/LangContext";
import { useAuth } from "../context/AuthContext";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "../components/ui/dialog";
import { Button } from "../components/ui/button";
import { Wallet as WalletIcon } from "lucide-react";

export default function Wallet() {
  const { t, lang } = useLang();
  const { user } = useAuth();
  const [data, setData] = useState({ balance: 0, transactions: [] });

  useEffect(() => {
    api.get("/wallet").then(({ data }) => setData(data));
  }, []);

  return (
    <main data-testid="wallet-page" className="max-w-3xl mx-auto px-6 md:px-10 py-10 md:py-14">
      <div className="text-[11px] uppercase tracking-[0.28em] text-[#7B5CBF]">{t("walletTitle")}</div>
      <h1 className="font-display text-4xl md:text-5xl mt-2 mb-8">{user?.email}</h1>

      <div className="border border-[#E5E1D8] rounded-md p-8 bg-white flex items-center justify-between">
        <div>
          <div className="text-xs uppercase tracking-widest text-[#767676]">{t("currentBalance")}</div>
          <div className="mt-2 font-display text-5xl" data-testid="wallet-balance">
            ${data.balance.toFixed(2)}
          </div>
        </div>
        <WalletIcon className="h-8 w-8 text-[#7B5CBF]" strokeWidth={1.5} />
      </div>

      <Dialog>
        <DialogTrigger asChild>
          <Button
            data-testid="how-to-topup-btn"
            className="mt-6 rounded-full bg-[#1A1738] hover:bg-[#2C2650] text-white"
          >
            {t("howToTopUp")}
          </Button>
        </DialogTrigger>
        <DialogContent className="bg-white">
          <DialogHeader>
            <DialogTitle className="font-display text-2xl">{t("howToTopUp")}</DialogTitle>
          </DialogHeader>
          <p className="text-sm text-[#1A1738] leading-relaxed">{t("topUpInstructions")}</p>
          <ol className="text-sm text-[#767676] list-decimal ms-4 space-y-2">
            <li>{lang === "ar" ? "قم بزيارة نقطة البيع الخاصة بنا" : "Visit our POS location in the Middle East"}</li>
            <li>{lang === "ar" ? "ادفع نقداً بالمبلغ الذي ترغب في إضافته" : "Pay cash for the amount you want to add"}</li>
            <li>{lang === "ar" ? "شارك بريدك الإلكتروني معنا" : "Share your account email with our team"}</li>
            <li>{lang === "ar" ? "سيتم شحن محفظتك خلال ساعات" : "Your wallet is credited within a few hours"}</li>
          </ol>
        </DialogContent>
      </Dialog>

      <div className="mt-12">
        <h2 className="font-display text-2xl mb-4">{t("transactions")}</h2>
        <div className="border border-[#E5E1D8] rounded-md bg-white divide-y divide-[#E5E1D8]">
          {data.transactions.length === 0 ? (
            <div className="p-6 text-sm text-[#767676]" data-testid="no-tx">{t("noTransactions")}</div>
          ) : (
            data.transactions.map((tx) => (
              <div key={tx.id} className="p-4 flex items-center justify-between" data-testid={`tx-${tx.id}`}>
                <div>
                  <div className="text-sm">{tx.note}</div>
                  <div className="text-xs text-[#767676]">{new Date(tx.created_at).toLocaleString()}</div>
                </div>
                <div className={`font-medium ${tx.amount > 0 ? "text-[#4d7c4d]" : "text-[#7B5CBF]"}`}>
                  {tx.amount > 0 ? "+" : ""}${tx.amount.toFixed(2)}
                </div>
              </div>
            ))
          )}
        </div>
      </div>
    </main>
  );
}
